<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from "@/utils/validate";

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    from: {
      type: Number,
      required: true,
    },
    menuItem: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    linkProps(url = "") {
      let domain, path;
      // 其他外部系统
      if (this.from === 2) {
        domain = `${this.menuItem?.domain ?? ""}`, path = `${url}`;
        return {
          is: "router-link",
          to: {
            path: `${url}`
          },
        };
      } else {
        //（兼容旧菜单逻辑）扶摇已有的嵌入其他系统的菜单项，走a标签跳转出去的逻辑例如菜单path配置的是https://xxx/xxx
        if (isExternal(url)) {
          return {
            is: 'a',
            href: url,
            target: '_blank',
            rel: 'noopener'
          }
        }
        return {
          is: "router-link",
          to: url,
        };
      }
    },
  },
};
</script>
